export default "__VITE_ASSET__4336d1b5__"